/**
 * 口令登录回包里的动态码步骤
 *
 * 后端在口令正确但需要动态码时回 { mfaRequired: true, enrollRequired, mfaTicket, ... }，没有用户信息；
 * 这里只认带票据的回包，其余返回 null（按普通登录回包处理）。
 */
import type { MfaChallenge } from '@/types'

function readText(source: Record<string, unknown>, key: string): string | null {
  const value = source[key]
  return typeof value === 'string' && value ? value : null
}

export function parseMfaChallenge(raw: unknown): MfaChallenge | null {
  if (!raw || typeof raw !== 'object') {
    return null
  }
  const source = raw as Record<string, unknown>
  const ticket = readText(source, 'mfaTicket')
  if (source.mfaRequired !== true || !ticket) {
    return null
  }
  const enrollRequired = source.enrollRequired === true
  return {
    enrollRequired,
    mfaTicket: ticket,
    otpauthUrl: enrollRequired ? readText(source, 'otpauthUrl') : null,
    qrcodeBase64: enrollRequired ? readText(source, 'qrcodeBase64') : null,
    otpSecret: enrollRequired ? readText(source, 'otpSecret') : null,
  }
}
